var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOrder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_21",
    "data-name": "Group 21",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.399,
    height: 45.399,
    viewBox: "0 0 30.399 30.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2435533773280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M2.553,22.869V7.55A5.047,5.047,0,0,1,7.54,2.563H22.859A5.047,5.047,0,0,1,27.846,7.55V22.869a5.047,5.047,0,0,1-4.987,4.987H7.54a5.047,5.047,0,0,1-4.987-4.987ZM0,7.254V23.165a7.618,7.618,0,0,0,7.244,7.244H23.155a7.45,7.45,0,0,0,2.909-.713,7.776,7.776,0,0,0,3.622-3.622,7.45,7.45,0,0,0,.713-2.909V7.254a7.45,7.45,0,0,0-.713-2.909,8.176,8.176,0,0,0-1.5-2.123,8.8,8.8,0,0,0-.969-.812A7.474,7.474,0,0,0,23.155.01H7.244A7.554,7.554,0,0,0,2.211,2.222,8.8,8.8,0,0,0,1.4,3.19,7.474,7.474,0,0,0,0,7.254Z",
    transform: "translate(0 -0.01)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M492.48,901.527a1.3,1.3,0,0,0,1.425,1.425h12.349a1.315,1.315,0,1,0-.059-2.612H493.964c-.8,0-1.484.449-1.484,1.187Z",
    transform: "translate(-484.88 -886.447)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M492.48,1313.208a1.241,1.241,0,0,0,1.187,1.365h12.825a1.278,1.278,0,0,0-.059-2.553H493.727a1.263,1.263,0,0,0-1.247,1.187Z",
    transform: "translate(-484.881 -1291.774)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M492.49,493.677a1.254,1.254,0,0,0,1.247,1.366h12.706a1.279,1.279,0,0,0,.059-2.553H493.678a1.244,1.244,0,0,0-1.187,1.187Z",
    transform: "translate(-484.89 -484.891)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrder);
export default __webpack_public_path__ + "static/media/IconOrder.543269e7948f724335f4639aa1d9c38a.svg";
export { ForwardRef as ReactComponent };